/* import __COLOCATED_TEMPLATE__ from './multi-metric-bar-chart-cta.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();